import { WrapperIonLoading } from './LoadingMessage.styles';
import { useEffect, useRef } from 'react';

interface IComponentProps {
  message: string;
  isOpen: boolean;
}

/*
  The reason for this particular wrapper is due to a bug in the IonLoading component. Using its isOpen property
  causes it to sometimes get stuck open even though the isOpen has been set to false. The problem is
  intermittent and can't be reproduced. It simply sometimes is an issue and sometimes is not. I still can't
  be certain if this particular component fixes the issue or the issue has gone away coincidently.
*/

export const LoadingMessage: React.FC<IComponentProps> = ({ message, isOpen }) => {
  const loadingRef = useRef<null | HTMLIonLoadingElement>(null);
  const isOpenRef = useRef(false);

  const presentLoading = async (loadingRef: HTMLIonLoadingElement) => {
    if (!isOpenRef.current) {
      isOpenRef.current = true;
      await loadingRef.present();
    }
  };

  const dismissLoading = async (loadingRef: HTMLIonLoadingElement) => {
    if (isOpenRef.current) {
      isOpenRef.current = false;
      await loadingRef.dismiss();
    }
  };

  useEffect(() => {
    if (loadingRef.current) {
      if (isOpen) {
        presentLoading(loadingRef.current);
      } else {
        dismissLoading(loadingRef.current);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingRef.current, isOpen]);

  return <WrapperIonLoading ref={loadingRef} message={message} />;
};
